/**
 * Canonical URL paths for internal Chrono admin tools.
 * Used by `ChronoAdminRoutes` in Routes and by `AdminLandingPage` tiles.
 */
export const ChronoAdminPaths = {
  ADMIN_HOME: '/__admin',
  DASHBOARD_TOOLS: '/__admin/dashboard-tools',
  DASHBOARD_TOOLS_CONVERTER: '/__admin/dashboard-tools/convert',
  EVALS: '/__admin/evals',
  METADATA_CATALOGUE: '/__admin/metadata-catalogue',
  ARTIFACT_BROWSER: '/__admin/artifacts',
  INVESTIGATIONS: '/__admin/investigations',
} as const;
